{
    // select actions
    const select = document.querySelector('.academy-select');

    select.addEventListener('click', (e) => {
        e.stopPropagation();

        if (e.target.tagName === 'A' && e.target.href.includes('/#')) {
            e.preventDefault();
            e.target.parentNode.classList.toggle('current-menu-ancestor');

            return;
        }

        select.classList.toggle('academy-select--opened');
    });


    // menu actions
    const menu = document.querySelector('.academy-menu');
    const menuLinks = menu.querySelectorAll('a[href="#"]');

    [...menuLinks].forEach(link => {
       link.addEventListener('click', e => {
           e.preventDefault();
           link.parentNode.classList.toggle('current-menu-ancestor');
       });
    });
}
